import React, { Suspense } from 'react';
import { useInView } from 'react-intersection-observer';
import cx from 'clsx';

import useScrollDirectionWithY, {
  DIRECTION_UP,
} from '~/hooks/useScrollDirectionWithY';

import MarketCardBanner from './MarketCardBanner';
import MarketCardFloating from './MarketCardFloating';

function MarketCardBannerWithFloatingContent() {
  const { scrollDirection } = useScrollDirectionWithY();
  const { ref, inView } = useInView({
    rootMargin: '0px 0px',
    threshold: 0,
  });

  return (
    <div className="px-20 py-8">
      <div ref={ref}>
        <MarketCardBanner />
      </div>
      {!inView && (
        <MarketCardFloating
          classNames={cx(
            'transition-transform duration-500',
            scrollDirection === DIRECTION_UP && 'translate-y-[52px]',
          )}
        />
      )}
    </div>
  );
}

const Skeleton = () => {
  return (
    <div className="w-full rounded-16 px-20 py-8">
      <div className="h-64 skeleton" />
    </div>
  );
};

export default function MarketCardBannerWithFloating() {
  return (
    <Suspense fallback={<Skeleton />}>
      <MarketCardBannerWithFloatingContent />
    </Suspense>
  );
}
